import React from 'react';
import AnalyticsGridHeader from '../analytics-grid-header/AnalyticsGridHeader';
import AnalyticsTrafficData from '../analytics-traffic-data/AnalyticsTrafficData';
import AnalyticsPagesData from '../analytics-pages-data/AnalyticsPagesData';
import AnalyticsAverageTimeSpentData from '../analytics-average-time-spent-data/AnalyticsAverageTimeSpentData';
import './analytics-grid.scss';
import AnalyticsPagesRadar from '../analytics-radar/AnalyticsPagesRadar';
import AnalyticsTimeBarChart from '../analytics-times-bar-chart/AnalyticsTimeBarChart';
import AnalyticsOverTimeTable from '../analytics-cards/analytics-over-time-table/AnalyticsOverTimeTable';

function AnalyticsGrid() {
    return (
        <div className='analytics-grid'>
            <AnalyticsGridHeader></AnalyticsGridHeader>
            <AnalyticsTrafficData></AnalyticsTrafficData>
            <AnalyticsOverTimeTable></AnalyticsOverTimeTable>
            {/* <AnalyticsTimeBarChart></AnalyticsTimeBarChart> */}
            <AnalyticsPagesData></AnalyticsPagesData>
            {/* <AnalyticsPagesRadar></AnalyticsPagesRadar> */}
            {/* <AnalyticsAverageTimeSpentData></AnalyticsAverageTimeSpentData> */}
        </div>
    );
}


export default AnalyticsGrid;
